<template lang="html">
	<div class="loader-container" v-bind:class="{'is-loading': isLoading, 'is-maskDisabled': isMaskDisabled}">
        <div class="loader-mask" ref="loaderMask"></div>
        <h1>
            <a class="logo app-logo c-hover" @click.prevent="logoClick" :href="this.$router.resolve({path: $parent.projectsPath}).href">
                <div class="logo-image c-hover" v-bind:class="{'is-disabled': $route.path.includes('/proje')}">
                    <svg viewBox="0 0 1050 1050" height="500" width="500" class="c-hover">
                        <path stroke-width='35' class="logo-path c-hover" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3294.875732421875 3294.875732421875" fill='none' stroke="#E6E6E6" id="logopath" 
                        d="M250,625c113.75-99.574,196-225,196-225v225l2.75,300c0,0-0.594,100-98.875,100
                        s-99.438-100-99.438-100s3.057-84.236,100.281-200s174.016-200,174.016-200l0.032,0.167c0,0,77.663-84.306,174.733-200.2
                        s99.733-200.133,99.733-200.133S797.381,24.836,699.1,24.967c-98.281,0.131-99.867,100.133-99.867,100.133l0.9,299.999
                        l0.275,99.826c0,0,0.683,100.012,98.958,101.031c98.276,1.018,101.031-98.958,101.031-98.958s-0.893-39.544-32.326-101.992
                        L799,425"/>
                        
                        <line class="arrow-1 c-hover" stroke-width='40' stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="1308.789794921875 1308.789794921875" fill='none' stroke="#E6E6E6" x1="825" y1="526" x2="227" y2="526"/>                        
                        <path class="arrow-2 c-hover" stroke-width='40' stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="715.7777709960938 715.7777709960938" fill='none' stroke="#E6E6E6" d="M227,525c113.7,99.6,196,225,196,225"/>
                        <path class="arrow-3 c-hover" stroke-width='40' stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="715.7777709960938 715.7777709960938" fill='none' stroke="#E6E6E6" d="M227,525c113.7-99.6,196-225,196-225"/>
                    </svg>
                </div>
                <span class="loader loader-nav" v-bind:style="{width: loaderWidth + '%'}"></span>
                <span class="loader-counter" v-bind:class="{'is-visible': loaderVisible}">
                    <span class="counter-number">{{ percentLoaded }}</span>
                    <span class="counter-percent">%</span>
                </span>
            </a>
        </h1>
	</div>
</template>

<script>

import AssetsLoader from 'assets-loader'
import LoaderMixin from './LoaderMixin.js'

export default {
    
    mixins: [LoaderMixin],
    
    data() {
        return {
            isLoading: true,
            isMaskDisabled: false,
            loaderWidth: 0,
            app: this.$parent.$parent,
            ticker: false,
            stage: new PIXI.Container(),
            displacementSprite: new PIXI.Sprite.fromImage('/static/images/clouds.jpg'),
            displacementFilter: false,
            renderer: false,
            bg: false,
            baseHeight: 0,
            baseWidth: 0,
            percentLoaded: 0,
            loaderVisible: true
        }
    },
        
    mounted() {
        var self = this;
        this.displacementFilter = new PIXI.filters.DisplacementFilter(this.displacementSprite);
        this.loaderCanvas();
        
		let loader = AssetsLoader()
		let assetsToLoad
        
        assetsToLoad = this.findAssets()
		loader.add(assetsToLoad)

		loader.on('progress', progress=>{
            var percent = Math.round(progress*100)
            this.loaderWidth < percent ? this.loaderWidth = percent : undefined
            this.percentLoaded < percent ? this.percentLoaded = percent : undefined
		})
		loader.on('complete', assets=>{
            
            self.LoadAnimationRemove();
            
            setTimeout(function () {
                self.isLoading = false
            }, 300)
            setTimeout(function () {
                if (self.$route.name !== 'projects_component' && !self.app.isMobile) {                    
                    self.app.launchSmoothScroll()
                }
                self.loaderWidth = 0
                self.app.firstLoad = false
                self.loaderVisible = false
            }, 600)
		})
		loader.start()        
    },
    
     methods: {
         
            loaderCanvas: function() {
                var self = this;
                this.baseWidth = this.$refs.loaderMask.clientWidth;
                this.baseHeight = this.$refs.loaderMask.clientHeight;
                this.renderer = new PIXI.autoDetectRenderer(this.baseWidth, this.baseHeight, {transparent: true});

                this.displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
                this.displacementSprite.scale.x = 2;
                this.displacementSprite.scale.y = 2;
                
                // PIXI tries to fit the filter bounding box to the renderer so we optionally bypass
                this.displacementFilter.autoFit = false;
                
                this.$refs.loaderMask.appendChild(this.renderer.view);
                this.stage.addChild(this.displacementSprite);
                this.stage.filters = [this.displacementFilter];
                this.renderer.render(this.stage);
                
                this.bg = new PIXI.Graphics();
                this.bg.beginFill(0x17161a);
                this.bg.drawRect(-(this.baseWidth*0.05), -(this.baseHeight*0.05), this.baseWidth*1.1, this.baseHeight*1.1);
                this.stage.addChild(this.bg);
                
                // on rend le masque transparent une fois le canvas ajouté
                this.$refs.loaderMask.style.backgroundColor = 'transparent';
                
                this.renderer.render(this.stage);
                
                // Ticker
                this.ticker = new PIXI.ticker.Ticker();        

                this.ticker.add(function(delta) {          
                    self.displacementSprite.x += 4 * delta/2;
                    self.displacementSprite.y += 3/2;

                    self.renderer.render(self.stage);                    
                });
                
                // On resize
                window.addEventListener('resize', _.throttle(this.resizeCanvas, 200))
            },
         
            LoadAnimationRemove: function() {
                var self = this;
                this.ticker.start();
                
                var baseTimeline = new TimelineMax({
                    onComplete: function() {
                        self.ticker.stop();
                        self.$refs.loaderMask.style.display = "none";
                     }
                });
                
                baseTimeline.clear();

                if (baseTimeline.isActive()) {
                    return;
                }        

                baseTimeline
                .to(self.displacementFilter.scale, 0.8, {x: 5000, y: 10000, ease: Power2.easeIn})
                .to(self.stage, 0.5, {alpha: 0, ease: Power2.easeOut}, 0.5)
                
                this.app.checkIfMobile()
                
                this.app.$refs.cursor.classList.remove('is-hidden');
            },
         
            LoadAnimationAdd: function() {
                this.app.$refs.cursor.classList.add('is-hidden');
                
                var self = this;
                this.$refs.loaderMask.style.display = "block";
                this.ticker.start();
                
                var baseTimeline = new TimelineMax({
                    onComplete: function() {
                        self.ticker.stop();
                     }
                });
                
                baseTimeline.clear();

                if (baseTimeline.isActive()) {
                    return;
                }        

                baseTimeline
                .to(self.displacementFilter.scale, 0.7, {x: 20, y: 20, ease: Power1.easeOut})
                .to(self.stage, 0.5, {alpha: 1, ease: Power2.easeOut}, 0.1)
            },
         
            resizeCanvas: function() {
                var maskWidth = window.innerWidth
                var maskHeight = window.innerHeight

                this.stage.width = maskWidth * 1.1
                this.stage.height = maskHeight * 1.1
                this.bg.width = maskWidth * 1.1
                this.bg.height = maskHeight * 1.1
                this.renderer.resize(maskWidth * 1.1, maskHeight * 1.1)
            },
         
            logoClick() {
                if(!this.isLoading) {
                    this.$router.push({path: this.$parent.projectsPath})
                }
            }
     }
    
}
    
</script>


// WEBPACK FOOTER //
// src/components/Loader/Loader.vue